import { Pipe, PipeTransform } from '@angular/core';
import { getDurationFormat } from '../../core/utils/duration.utils';

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {

  transform(duration: number, format: string = '{HOURS}:{MINS}:{SECS}', nullText = '0', limitToShowInDays: number | false = false): any {
    return (duration) ? this.transformDuration(duration, format, limitToShowInDays) : nullText;
  }

  private transformDuration(duration: number, format: string, limitToShowInDays: number | false) {
    return (!limitToShowInDays || duration < limitToShowInDays)
      ? getDurationFormat(format, duration)
      : '';
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/pipes/duration.pipe.ts